export const payoutLineItemCsvFilter = (csvName, role, moduleName, content) => {
  let csv = content
  ;({
    'Device Payout': () => {
      ;({
        lineItem: () => {
          ;({
            ZD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['ZD Code'] = obj['zdCode'] ?? ''
                  obj['ZD Name'] = obj['zdName'] ?? ''
                  obj['RDS Code'] = obj['rdsCode'] ?? ''
                  obj['RDS Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            RDS: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['ZD Code'] = obj['zdCode'] ?? ''
                  obj['ZD Name'] = obj['zdName'] ?? ''
                  obj['RDS Code'] = obj['rdsCode'] ?? ''
                  obj['RDS Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            ARD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['ARD Code'] = obj['zdCode'] ?? ''
                  obj['ARD Name'] = obj['zdName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            MARD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['MARD Code'] = obj['zdCode'] ?? ''
                  obj['MARD Name'] = obj['zdName'] ?? ''
                  obj['Retailer'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            RZD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['RZD Code'] = obj['zdCode'] ?? ''
                  obj['RZD Name'] = obj['zdName'] ?? ''
                  obj['Retailer'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            ITZ: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['IT ZD Code'] = obj['zdCode'] ?? ''
                  obj['IT ZD Name'] = obj['zdName'] ?? ''
                  obj['ITD Code'] = obj['rdsCode'] ?? ''
                  obj['ITD Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            ITD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['IT ZD Code'] = obj['zdCode'] ?? ''
                  obj['IT ZD Name'] = obj['zdName'] ?? ''
                  obj['ITD Code'] = obj['rdsCode'] ?? ''
                  obj['ITD Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            ZDMT: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['ZDMT Code'] = obj['zdCode'] ?? ''
                  obj['ZDMT Name'] = obj['zdName'] ?? ''
                  obj['CHAIN Code'] = obj['rdsCode'] ?? ''
                  obj['CHAIN Name'] = obj['rdsName'] ?? ''
                  obj['Store Code'] = obj['partner'] ?? ''
                  obj['Store Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            CHAIN: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['ZDMT Code'] = obj['zdCode'] ?? ''
                  obj['ZDMT Name'] = obj['zdName'] ?? ''
                  obj['CHAIN Code'] = obj['rdsCode'] ?? ''
                  obj['CHAIN Name'] = obj['rdsName'] ?? ''
                  obj['Store Code'] = obj['partner'] ?? ''
                  obj['Store Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            },
            END: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['Invoice No'] = obj['invoiceNo'] ?? ''
                  obj['Invoice Date'] = obj['invoiceDate'] ?? ''
                  obj['ED Code'] = obj['zdCode'] ?? ''
                  obj['ED Name'] = obj['zdName'] ?? ''
                  obj['Retailer'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['Material'] = obj['material'] ?? ''
                  obj['Material Description'] = obj['materialDescr'] ?? ''
                  obj['Brand Description'] = obj['brandDescr'] ?? ''
                  obj['JIO Center'] = obj['jioCenter'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Gross Amount'] = obj['val'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Dealer Price'] = obj['dealerPrice'] ?? ''
                  delete obj['state']
                  delete obj['region']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['brandDescr']
                  delete obj['invoiceNo']
                  delete obj['invoiceDate']
                  delete obj['jioCenter']
                  delete obj['material']
                  delete obj['materialDescr']
                  delete obj['dealerPrice']
                  delete obj['points']
                  delete obj['partnerRoleName']
                  return obj
                })
              return csv
            }
          }[role]())
          return csv
        },
        header: () => {
          ;({
            ZD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['ZD Code'] = obj['zdCode'] ?? ''
                  obj['ZD Name'] = obj['zdName'] ?? ''
                  obj['RDS Code'] = obj['rdsCode'] ?? ''
                  obj['RDS Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            RDS: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['ZD Code'] = obj['zdCode'] ?? ''
                  obj['ZD Name'] = obj['zdName'] ?? ''
                  obj['RDS Code'] = obj['rdsCode'] ?? ''
                  obj['RDS Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            ARD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['ARD Code'] = obj['zdCode'] ?? ''
                  obj['ARD Name'] = obj['zdName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            MARD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['MARD Code'] = obj['zdCode'] ?? ''
                  obj['MARD Name'] = obj['zdName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            RZD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['RZD Code'] = obj['zdCode'] ?? ''
                  obj['RZD Name'] = obj['zdName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            ITZ: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['IT ZD Code'] = obj['zdCode'] ?? ''
                  obj['IT ZD Name'] = obj['zdName'] ?? ''
                  obj['ITD Code'] = obj['rdsCode'] ?? ''
                  obj['ITD Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            ITD: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['IT ZD Code'] = obj['zdCode'] ?? ''
                  obj['IT ZD Name'] = obj['zdName'] ?? ''
                  obj['ITD Code'] = obj['rdsCode'] ?? ''
                  obj['ITD Name'] = obj['rdsName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            ZDMT: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['ZDMT Code'] = obj['zdCode'] ?? ''
                  obj['ZDMT Name'] = obj['zdName'] ?? ''
                  obj['CHAIN Code'] = obj['rdsCode'] ?? ''
                  obj['CHAIN Name'] = obj['rdsName'] ?? ''
                  obj['Store Code'] = obj['partner'] ?? ''
                  obj['Store Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            CHAIN: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['ZDMT Code'] = obj['zdCode'] ?? ''
                  obj['ZDMT Name'] = obj['zdName'] ?? ''
                  obj['CHAIN Code'] = obj['rdsCode'] ?? ''
                  obj['CHAIN Name'] = obj['rdsName'] ?? ''
                  obj['Store Code'] = obj['partner'] ?? ''
                  obj['Store Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  obj['Partner Role Type'] = obj['partnerRoleType'] ?? ''
                  obj['Partner Role Name'] = obj['partnerRoleName'] ?? ''
                  obj['Record Number'] = obj['recordNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            },
            END: () => {
              csv =
                content &&
                content.map(obj => {
                  obj['Scheme'] = obj['scheme'] ?? ''
                  obj['Scheme Number'] = obj['schemeNo'] ?? ''
                  obj['From Date'] = obj['fromDate'] ?? ''
                  obj['To Date'] = obj['toDate'] ?? ''
                  obj['Hierarchy Date'] = obj['hierarchyDate'] ?? ''
                  obj['ED Code'] = obj['zdCode'] ?? ''
                  obj['ED Name'] = obj['zdName'] ?? ''
                  obj['Retailer Code'] = obj['partner'] ?? ''
                  obj['Retailer Name'] = obj['partnerName'] ?? ''
                  obj['R4J State'] = obj['state'] ?? ''
                  obj['Region'] = obj['region'] ?? ''
                  obj['Quantity'] = obj['qty'] ?? ''
                  obj['Value'] = obj['val'] ?? ''
                  obj['Rate'] = obj['rate'] ?? ''
                  obj['Payout'] = obj['payout'] ?? ''
                  obj['Clawback Deduction'] = obj['cbDeduction'] ?? ''
                  obj['TDS Deduction'] = obj['tdsDeduction'] ?? ''
                  obj['Net Payable'] = obj['netPayable'] ?? ''
                  obj['Eligibility Value'] = obj['elgval'] ?? ''
                  obj['Percentage Achievement'] = obj['perchAchv'] ?? ''
                  obj['Settlement Doc no'] = obj['setlDocNo'] ?? ''
                  obj['Settlement Date'] = obj['setlDate'] ?? ''
                  obj['ERP Doc Number'] = obj['erpDocNo'] ?? ''
                  delete obj['region']
                  delete obj['state']
                  delete obj['scheme']
                  delete obj['schemeNo']
                  delete obj['fromDate']
                  delete obj['toDate']
                  delete obj['hierarchyDate']
                  delete obj['zdCode']
                  delete obj['zdName']
                  delete obj['rdsCode']
                  delete obj['rdsName']
                  delete obj['partner']
                  delete obj['partnerName']
                  delete obj['qty']
                  delete obj['val']
                  delete obj['rate']
                  delete obj['payout']
                  delete obj['cbDeduction']
                  delete obj['tdsDeduction']
                  delete obj['netPayable']
                  delete obj['elgval']
                  delete obj['perchAchv']
                  delete obj['setlDocNo']
                  delete obj['setlDate']
                  delete obj['erpDocNo']
                  delete obj['partnerRoleType']
                  delete obj['partnerRoleName']
                  delete obj['recordNo']
                  return obj
                })
              return csv
            }
          }[role]())
          return csv
        }
      }[csvName]())
      return csv
    }
  }[moduleName]())
  return csv
}
